import { isElement } from '../detectInlineType';
import c from './_inlineVideo.module.scss';

import { type DOMNode, domToReact, type Element } from 'html-react-parser';

export interface InlineVideoProps {
  element: Element;
}

export function InlineVideo({ element }: InlineVideoProps) {
  const figChildren = (element.children as DOMNode[]).filter(isElement);
  const video = figChildren.find((el) => el.name === 'video');
  const figcaptionEl = figChildren.find((el) => el.name === 'figcaption');

  if (!video) return null;

  const { src = '', poster } = video.attribs;
  const figureClass = element.attribs.class ?? '';
  const caption = figcaptionEl ? domToReact(figcaptionEl.children as DOMNode[]) : null;

  return (
    <figure className={figureClass}>
      <video data-testid="inline-video" className={c.video} controls poster={poster} src={src} />
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
}
